import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitobhopalcab() {



    const cardData = {

keyword: "Mumbai to Bhopal Cab",

headingDescription:
    "Mumbai Airport Cab offers reliable and affordable Mumbai to Bhopal Cab services for long-distance intercity travel, business trips, family tours, and one-way or round-trip journeys. We provide well-maintained vehicles including Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus with professional and experienced chauffeurs. With 24x7 availability, transparent pricing, doorstep pickup in Mumbai, and safe highway driving across Maharashtra and Madhya Pradesh routes, we ensure a smooth, comfortable, and hassle-free travel experience to Bhopal.",

topPlaces: [
    {
        title: "Upper Lake (Bhojtal)",
        description:
            "Upper Lake, also known as Bhojtal, is one of the largest artificial lakes in India and a major attraction in Bhopal, offering boating, sunset views, and peaceful surroundings."
    },
    {
        title: "Van Vihar National Park",
        description:
            "Van Vihar National Park is a wildlife sanctuary located in the heart of Bhopal, known for its tigers, leopards, and natural forest environment along the lake."
    },
    {
        title: "Sanchi Stupa",
        description:
            "Sanchi Stupa is a UNESCO World Heritage Site located near Bhopal, famous for its ancient Buddhist monuments and historical significance."
    },
    {
        title: "Bharat Bhavan",
        description:
            "Bharat Bhavan is a multi-arts complex showcasing modern art, theatre, and cultural exhibitions, making it a key cultural landmark in Bhopal."
    },
    {
        title: "Bhimbetka Rock Shelters",
        description:
            "Bhimbetka Rock Shelters are prehistoric caves and UNESCO World Heritage Sites featuring ancient rock paintings dating back thousands of years."
    },
    {
        title: "Taj-ul-Masajid",
        description:
            "Taj-ul-Masajid is one of the largest mosques in India, known for its grand architecture and spiritual importance in Bhopal."
    },
    {
        title: "Lower Lake",
        description:
            "Lower Lake is a scenic water body in Bhopal connected to Upper Lake, offering boating and relaxing views within the city."
    },
    {
        title: "Raisen Fort",
        description:
            "Raisen Fort is a historic hill fort near Bhopal known for its architecture, ancient temples, and panoramic views of the surrounding region."
    },
    {
        title: "Bhimbetka Wildlife Area",
        description:
            "The Bhimbetka region is also surrounded by forest areas and natural landscapes ideal for eco-tourism and exploration."
    },
    {
        title: "Kerwa Dam",
        description:
            "Kerwa Dam is a peaceful picnic spot near Bhopal surrounded by forests and hills, popular for short leisure trips and nature outings."
    }
],



services: [
{
name: "Mumbai to Saputara Cabs",
description: "Mumbai Airport Cab offers Mumbai to Saputara Cabs service for safe, comfortable, and reliable travel to the beautiful hill station of Saputara in Gujarat. Whether you are planning a family vacation, weekend getaway, honeymoon trip, group tour, or nature escape, we provide well-maintained vehicles including Sedan, SUV, Innova, Innova Crysta, Kia Carens, Tempo Traveller, and luxury options. Our professional chauffeurs ensure smooth highway driving, scenic route travel, timely pickup, and complete safety throughout the journey. With doorstep pickup from Mumbai, flexible travel plans, transparent pricing, luggage assistance, and 24x7 support, we make your hill station trip comfortable, enjoyable, and stress-free."
},
{
name: "Mumbai to Saputara Taxi",
description: "Mumbai to Saputara Taxi service by Mumbai Airport Cab provides dependable intercity travel for tourists and families visiting Saputara hill station. Our clean, air-conditioned taxis are driven by experienced chauffeurs who ensure safe driving through highway and ghat sections. We offer flexible pickup options, smooth travel experience, and reliable service for a comfortable journey from Mumbai to Saputara."
},
{
name: "Mumbai to Saputara Cab Fare",
description: "Mumbai to Saputara Cab Fare with Mumbai Airport Cab is transparent, affordable, and based on vehicle type, distance, and travel requirements. We provide clear pricing with no hidden charges and flexible packages for one-way and round-trip journeys. Our goal is to offer budget-friendly yet comfortable travel for all types of passengers heading to Saputara."
},
{
name: "Mumbai to Saputara Car Rental",
description: "Mumbai Airport Cab offers Mumbai to Saputara Car Rental service with chauffeur-driven vehicles for hill station travel. Our fleet includes sedans and spacious SUVs ideal for family trips and group travel. We ensure comfortable seating, luggage support, and safe driving through scenic and ghat routes for a smooth travel experience."
},
{
name: "Mumbai to Saputara One Way Cab",
description: "Mumbai to Saputara One Way Cab service provides affordable travel for passengers who need a single journey without return charges. Mumbai Airport Cab ensures transparent pricing, comfortable vehicles, and professional drivers for tourism, weekend trips, and intercity travel."
},
{
name: "Mumbai to Saputara Outstation Cab",
description: "Mumbai to Saputara Outstation Cab service offers reliable long-distance transportation for hill station travel. Mumbai Airport Cab provides well-maintained vehicles, experienced chauffeurs, and flexible schedules to ensure safe and enjoyable travel from Mumbai to Saputara."
},
{
name: "Mumbai to Saputara Taxi Service",
description: "Mumbai Airport Cab provides Mumbai to Saputara Taxi Service with professional drivers, clean vehicles, and 24x7 availability. Our service ensures punctual pickup, safe highway driving, and smooth travel experience for families and tourists."
},
{
name: "Mumbai to Saputara Hill Station Cab",
description: "Mumbai to Saputara Hill Station Cab service is specially designed for scenic travel to Saputara’s lakes, viewpoints, and green landscapes. Mumbai Airport Cab ensures comfortable vehicles, experienced drivers, and safe ghat driving for a relaxing hill station experience."
},
{
name: "Mumbai to Saputara Weekend Cab",
description: "Mumbai to Saputara Weekend Cab service offers quick getaway travel solutions for short trips and holidays. Mumbai Airport Cab provides flexible booking, comfortable vehicles, and reliable chauffeurs for a smooth weekend escape to Saputara."
},
{
name: "Mumbai to Saputara Family Cab",
description: "Mumbai to Saputara Family Cab service provides safe and spacious travel options for families visiting Saputara. Mumbai Airport Cab ensures comfortable seating, luggage space, and professional drivers for a stress-free family holiday experience."
},
{
name: "Mumbai to Saputara Innova Cab",
description: "Mumbai Airport Cab offers Mumbai to Saputara Innova Cab service for families and groups needing spacious and comfortable travel. Our Innova vehicles ensure smooth ride quality, ample seating, and luggage capacity for long hill station journeys."
},
{
name: "Mumbai to Saputara SUV Cab",
description: "Mumbai to Saputara SUV Cab service provides powerful and comfortable vehicles suitable for highway and hill travel. Mumbai Airport Cab ensures safe driving, spacious interiors, and smooth journey experience for groups and families."
},
{
name: "Mumbai to Saputara Round Trip Cab",
description: "Mumbai to Saputara Round Trip Cab service offers complete return journey solutions for weekend vacations and family trips. Mumbai Airport Cab ensures flexible scheduling, professional chauffeurs, and comfortable vehicles for a seamless round trip experience."
},
{
name: "Mumbai to Saputara Tour Cab",
description: "Mumbai to Saputara Tour Cab service provides customized travel plans for sightseeing and holiday trips. Mumbai Airport Cab ensures comfortable vehicles, scenic travel routes, and reliable service for a memorable Saputara tour experience."
},
{
name: "Mumbai to Saputara Travel Service",
description: "Mumbai to Saputara Travel Service offers complete transportation solutions for tourists and families visiting Saputara hill station. Mumbai Airport Cab ensures safe, comfortable, and well-organized travel with professional drivers and flexible itineraries."
},
{
name: "Mumbai to Saputara Budget Cab",
description: "Mumbai to Saputara Budget Cab service provides economical travel options for hill station trips without compromising comfort and safety. Mumbai Airport Cab ensures affordable pricing, clean vehicles, and reliable service for all passengers."
},
{
name: "Mumbai to Saputara Luxury Cab",
description: "Mumbai to Saputara Luxury Cab service offers premium vehicles and high-end travel comfort for VIP guests, honeymooners, and special occasions. Mumbai Airport Cab ensures luxury interiors, professional chauffeurs, and a smooth travel experience."
},
{
name: "Mumbai to Saputara Group Cab",
description: "Mumbai to Saputara Group Cab service provides spacious vehicles like Tempo Traveller and Mini Bus for group travel. Mumbai Airport Cab ensures comfortable seating, safe driving, and coordinated travel for large families and tour groups."
},
{
name: "Mumbai to Saputara Scenic Cab",
description: "Mumbai to Saputara Scenic Cab service is designed for travelers who want to enjoy the beautiful landscapes and nature views during the journey. Mumbai Airport Cab ensures smooth driving, comfortable vehicles, and a relaxing travel experience through scenic routes."
}
],

tableData: [
["Mumbai to Saputara Cabs","Mumbai to Saputara Taxi"],
["Mumbai to Saputara Cab Fare","Mumbai to Saputara Car Rental"],
["Mumbai to Saputara One Way Cab","Mumbai to Saputara Outstation Cab"],
["Mumbai to Saputara Taxi Service","Mumbai to Saputara Hill Station Cab"],
["Mumbai to Saputara Weekend Cab","Mumbai to Saputara Family Cab"],
["Mumbai to Saputara Innova Cab","Mumbai to Saputara SUV Cab"],
["Mumbai to Saputara Round Trip Cab","Mumbai to Saputara Tour Cab"],
["Mumbai to Saputara Budget Cab","Mumbai to Saputara Luxury Cab"]
],












whychoose: [
    {
        WhyChooseheading: "Reliable Mumbai to Bhopal Cab Service",
        WhyChoosedescription: "Mumbai Airport Cabs provides dependable Mumbai to Bhopal Cab services for business travelers, families, students, tourists, and corporate professionals seeking comfortable interstate travel."
    },
    {
        WhyChooseheading: "Convenient Travel Between Mumbai and Bhopal",
        WhyChoosedescription: "Our cab service offers seamless connectivity between Mumbai and Bhopal for business meetings, family visits, educational purposes, medical travel, and leisure trips."
    },
    {
        WhyChooseheading: "Perfect for Business and Personal Travel",
        WhyChoosedescription: "Bhopal is a major administrative, educational, and commercial city, making it a popular destination for professionals, families, and tourists."
    },
    {
        WhyChooseheading: "Wide Range of Vehicle Options",
        WhyChoosedescription: "Customers can choose Sedan cars, Ertiga, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, Mini Buses, and premium vehicles according to passenger count and travel requirements."
    },
    {
        WhyChooseheading: "One-Way and Round Trip Booking Available",
        WhyChoosedescription: "Whether you require a one-way transfer, round trip, multi-day travel, or a customized itinerary, we provide flexible booking options."
    },
    {
        WhyChooseheading: "Pickup Available Across Mumbai",
        WhyChoosedescription: "Doorstep pickup services are available from Mumbai Airport, Navi Mumbai, Thane, Dombivli, Kalyan, Andheri, Borivali, Bandra, Dadar, Powai, and nearby areas."
    },
    {
        WhyChooseheading: "Experienced Drivers for Interstate Travel",
        WhyChoosedescription: "Our professional chauffeurs are experienced in long-distance interstate travel and ensure safe, comfortable, and hassle-free journeys."
    },
    {
        WhyChooseheading: "Ideal for Families, Corporate Travelers, and Groups",
        WhyChoosedescription: "From solo travelers and families to corporate teams and group travelers, we provide suitable vehicle options for every travel requirement."
    }
]
};

const faqData = [
    {
        question: "Why do travelers book Mumbai to Bhopal Cabs?",
        answer: "Bhopal attracts travelers for business meetings, government work, education, tourism, family visits, medical treatment, and corporate travel."
    },
    {
        question: "Can I book a one-way cab from Mumbai to Bhopal?",
        answer: "Yes, one-way cab services are available along with round-trip and customized travel packages."
    },
    {
        question: "Which vehicle is suitable for Mumbai to Bhopal travel?",
        answer: "Sedan cars, Ertiga, Innova Crysta, Kia Carens, SUVs, and Tempo Travellers are popular choices for comfortable long-distance travel."
    },
    {
        question: "Do you provide multi-day travel packages?",
        answer: "Yes, customers can book multi-day travel packages according to their schedule and travel requirements."
    },
    {
        question: "Can corporate travelers use this service regularly?",
        answer: "Yes, many executives, business owners, and corporate professionals use our Mumbai to Bhopal Cab services for official travel."
    },
    {
        question: "Are Tempo Travellers available for group travel?",
        answer: "Yes, Tempo Travellers and Mini Buses are available for family groups, corporate teams, educational tours, and tourist groups."
    },
    {
        question: "Can I get pickup from Mumbai Airport?",
        answer: "Yes, pickup services are available from Mumbai Airport, hotels, railway stations, offices, and residential locations."
    },
    {
        question: "Can multiple stops be included during the journey?",
        answer: "Yes, customers can customize their itinerary and include sightseeing locations, business destinations, restaurants, and personal stops."
    },
    {
        question: "Is advance booking recommended for Mumbai to Bhopal travel?",
        answer: "Yes, advance booking is recommended to secure your preferred vehicle and ensure smooth travel planning."
    },
    {
        question: "How can I book a Mumbai to Bhopal Cab?",
        answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cabs."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Amit Verma",
        feedback:
            "I booked a cab from Mumbai to Bhopal for a business visit and was impressed with the professionalism. The vehicle was comfortable and the driver ensured a smooth interstate journey.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Swati Tiwari",
        feedback:
            "Our family traveled to Bhopal comfortably with Mumbai Airport Cabs. The cab was spacious, clean, and the entire trip was managed efficiently from pickup to destination.",
        rating: 5
    }
];





































   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];













const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Mumbai to Bhopal Cab",
"image": "https://www.mumbaiairportcabs.com/assets/images/mumbai-to-bhopal-cab.jpg",
"description": "Book Mumbai to Bhopal cab service for long-distance outstation travel, business trips, and family journeys. Mumbai Airport Cabs offers reliable one-way and round-trip taxi options with professional drivers, comfortable cars including sedans and SUVs, and 24x7 service.",
"brand": {
"@type": "Brand",
"name": "Mumbai Airport Cabs"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.mumbaiairportcabs.com/mumbai-to-bhopal-cab"
}
};




    return (
        <div>

<Helmet>
  <title>Mumbai to Bhopal Cab | Outstation Taxi Service | +91 9545731161</title>

<meta
 name="description"
 content="Book Mumbai to Bhopal cab for outstation travel, business trips, and family journeys. Safe and comfortable long-distance taxi service with professional drivers and 24x7 availability."
/>

<meta
 name="keywords"
 content="mumbai to bhopal cab, mumbai to bhopal taxi, mumbai to bhopal cab fare, mumbai to bhopal car rental, mumbai to bhopal one way cab, mumbai to bhopal outstation cab, mumbai to bhopal long distance cab service"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>









            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/52.jpeg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaitobhopalcab;